import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from '@material-ui/core/Input';
import { auth } from '../../firebase/index';
import KobooRoundInput from '../../constants/KobooRoundInput.css';
import KobooButton from '../Layout/KobooButton';
import styles from '../../constants/stylesDefault';
import * as routes from '../../constants/routes';
import { handleError } from '../../store/infos/actions';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
};

export class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

    onSubmit = (event) => {
      const { passwordOne } = this.state;

      const {
        history,
      } = this.props;

      auth.doPasswordUpdate(passwordOne)
        .then(() => {
          this.setState(() => ({ ...INITIAL_STATE }));
          history.push(routes.ACCOUNT);
        })
        .catch((error) => {
          this.props.handleError(error);
        });

      event.preventDefault();
    };

    render() {
      const {
        passwordOne,
        passwordTwo,
      } = this.state;

      const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '';

      return (
            <form onSubmit={this.onSubmit} style={styles.center}>
                <Input
                    style={KobooRoundInput.round}
                    value={passwordOne}
                    onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
                    type="password"
                    placeholder="New Password"
                    id="newpw-pw1"
                    disableUnderline={true}
                />
                <Input
                    style={KobooRoundInput.round}
                    value={passwordTwo}
                    onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
                    type="password"
                    placeholder="Confirm New Password"
                    id="newpw-pw2"
                    disableUnderline={true}
                />
                <KobooButton disabled={isInvalid} type="submit">
                    Changer
                </KobooButton>
            </form>
      );
    }
}

export default connect(null, {handleError})(PasswordChangeForm);



// WEBPACK FOOTER //
// ./src/components/PasswordChangeForm/PasswordChangeForm.jsx